import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { CUIHStack, CUIStack, CUIStackDivider } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import CUIConnectLogo from 'connect-dot-com-ui-components/Components/CUIConnectLogo/CUIConnectLogo';
import CUILink from 'connect-dot-com-ui-components/Components/CUILink/CUILink';
import CUIText from 'connect-dot-com-ui-components/Components/CUIText/CUIText';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import { APP_NAME, buildLink, DOMAIN_NAME } from 'connect-dot-com-ui-components/utils/urls';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useContext } from 'react';
import CUIRouterLink from 'connect-dot-com-ui-components/Components/CUIRouterLink/CUIRouterLink';

const Footer = () => {
  const {
    trackInteraction
  } = useContext(TrackerContext);

  function trackFooterInteraction(linkName) {
    trackInteraction('footer click', {
      value: linkName
    });
  }

  return /*#__PURE__*/_jsx(CUIBox, {
    as: "footer",
    role: "contentinfo",
    minHeight: 168,
    backgroundColor: "SOLARIS.extraLight",
    children: /*#__PURE__*/_jsxs(CUIStack, {
      direction: {
        base: 'column',
        md: 'row'
      },
      padding: 8,
      spacing: {
        base: 8,
        md: '0.5rem'
      },
      maxW: "1280px",
      justify: "space-between",
      ml: "auto",
      mr: "auto",
      children: [/*#__PURE__*/_jsxs(CUIStack, {
        direction: "column",
        spacing: 4,
        children: [/*#__PURE__*/_jsx(CUIConnectLogo, {
          maxW: "180px"
        }), /*#__PURE__*/_jsx(CUIText, {
          fontSize: "xs",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.footer.copyrightNotice",
            options: {
              year: new Date().getFullYear().toString()
            }
          })
        }), /*#__PURE__*/_jsxs(CUIHStack, {
          divider: /*#__PURE__*/_jsx(CUIStackDivider, {}),
          fontSize: "xs",
          children: [/*#__PURE__*/_jsx(CUILink, {
            variant: "homepage",
            href: "https://legal.hubspot.com/connect-tou",
            isExternal: true,
            onClick: () => trackFooterInteraction('terms of use'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.footer.termsOfUse"
            })
          }), /*#__PURE__*/_jsx(CUILink, {
            variant: "homepage",
            href: "https://legal.hubspot.com/privacy-policy",
            isExternal: true,
            onClick: () => trackFooterInteraction('privacy policy'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.footer.privacyPolicy"
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(CUIStack, {
        direction: "row",
        spacing: 16,
        children: /*#__PURE__*/_jsxs(CUIStack, {
          children: [/*#__PURE__*/_jsx(CUILink, {
            variant: "homepage",
            href: buildLink('', {
              domainOverride: DOMAIN_NAME.HUBSPOT,
              hubspotAppOverride: APP_NAME.AUTHED,
              forceNotLocal: true
            }),
            onClick: () => trackFooterInteraction('members'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.footer.members"
            })
          }), /*#__PURE__*/_jsx(CUILink, {
            variant: "homepage",
            href: "https://academy.hubspot.com/",
            isExternal: true,
            onClick: () => trackFooterInteraction('academy'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.footer.academy"
            })
          }), /*#__PURE__*/_jsx(CUIRouterLink, {
            variant: "homepage",
            to: "/code-of-conduct",
            "data-test-id": "code-of-conduct",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.footer.codeOfConduct"
            })
          }), /*#__PURE__*/_jsx("span", {
            className: "hs-footer-cookie-settings",
            hidden: true,
            children: /*#__PURE__*/_jsx(CUILink, {
              href: "javascript:void(0)"
            })
          })]
        })
      })]
    })
  });
};

export default Footer;